import { debounce, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { apiCall } from "../../services/authServieces";
import ShowSnackBar from "../../components/snackBar";
import Plus from "../../Assets/images/plus.png";
import React, { useState, useEffect } from "react";
import "../../css/wb_manage_dealer.css";
import {
  AddUser,
  ChangePassword,
  deleteDealers,
  GetPinnacleUser,
  UpdateUser,
} from "../../services/manageDealerService";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import AlertDialog from "../../components/ConfirmDialog";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import { formatDate, getRandomNum } from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SearchIcon from "@mui/icons-material/Search";
import LockResetIcon from "@mui/icons-material/LockReset";

const WbManageDealer = () => {
  const navigate = useNavigate();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [showCheck, setShowCheck] = useState(true);
  const [showWhatsappField, setShowWhatsappField] = useState(false);
  const [showCheckApi, setShowCheckApi] = useState(true);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [dealerCodeAvailable, setDealerCodeAvailable] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = React.useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [update, setUpdate] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = useState([]);

  const [passwords, setPasswords] = useState({
    password: "",
    confirmPassword: "",
  });
  const [errorMessage, setErrorMessage] = useState("");

  const [open, setOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogDescription, setDialogDescription] = useState("");
  const [ChangePasswordModal, setChangePasswordModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);

  const openDialog = (title, description) => {
    setDialogTitle(title);
    setDialogDescription(description);
    setOpen(true);
  };

  const [formValues, setFormValues] = useState({
    dealerCode: "",
    companyName: "",
    dealerName: "",
    tradeName: "",
    apiKey: "",
    whatsappBusinessAccountId: "",
    location: "",
    state: "",
    district: "",
    city: "",
    upassword: "",
    region: "",
    zone: "",
    uemail: "",
    mobile: "",
    status: "Active",
    // oem_id:"",
    // oem_dealer:"",
    country_mob_code:"",
    project_no:"",
    p_api_key:"",
    template_api_key:"",
    version:"",
    template_cost:0,
    template_platform_cost:0,
    service_cost:0,
    service_platform_cost:0,
    boat_id:"",
    client_id:"",
    google_id:"",
    client_name:"",
    client_type:"",
    access_token_validity:"",
    client_secret:""
    
  });
  const [formErrors, setFormErrors] = useState({});
  const [snackBar, setSnackBar] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const columns = [
    { id: "company_name", label: "Company" },
    { id: "user_id", label: "Customer Id" },
    { id: "user_name", label: "Customer Name" },
    { id: "user_phone", label: "Mobile" },
    { id: "user_email", label: "Email Id" },
    { id: "created_date", label: "Created Date" },
    // { id: "trade_name", label: "Trade Name" },
    // { id: "location", label: "Location" },
    // { id: "city", label: "City" },
    // { id: "state", label: "State" },
    // { id: "zone", label: "Zone" },
    // { id: "status", label: "Status" },
    { id: "action", label: "Action" },
  ];

  const [ projectAPIKeyAvailable, setProjectAPIKeyAvailable ] = useState(false)
  const [ templateAPIKeyAvailable, setTemplateAPIKeyAvailable ] = useState(false)


  // const handleEditModalToggle = () => setIsEditModalOpen(!isEditModalOpen);
  const handleAddModalToggle = () => {
    setShowCheck(true);
    setUpdate(false);
    setFormValues({});
    setDealerCodeAvailable(false);
    const randomDealerCode = getRandomNum();
    setFormValues((prevValues) => ({
      ...prevValues,
      dealerCode: randomDealerCode.toString(),
    }));
    setUpdate(false);
    setFormErrors({});
    setIsAddModalOpen(!isAddModalOpen);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "dealerCode") {
      setDealerCodeAvailable(false);
      setShowCheck(true);
    }

    if (name === "apiKey") {
      setShowCheckApi(true);
    }
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleCloseSnackBar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBar((prevState) => ({ ...prevState, open: false }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formValues.dealerCode) errors.dealerCode = "Dealer Code is required";
    if (!formValues.companyName)
      errors.companyName = "Company Name is required";
    if (!formValues.dealerName) errors.dealerName = "Dealer Name is required";
    if (!formValues.tradeName) errors.tradeName = "Trade Name is required";
    if (!formValues.location) errors.location = "Location is required";
    if (!formValues.state) errors.state = "State is required";
    if (!formValues.district) errors.district = "District is required";
    if (!formValues.city) errors.city = "City is required";
    if (!formValues.region) errors.region = "Region is required";
    if (!formValues.zone) errors.zone = "Zone is required";
    if (!formValues.uemail) errors.email = "Email is required";
    if (!formValues.mobile) errors.mobile = "Mobile is required";
    // if (!formValues.apiKey) errors.mobile = "API key is required";
    if (!update) {
      if (!formValues.upassword) errors.password = "Password is required";
    }

    if (formValues.status=='none' || !formValues.status) errors.status = "Status is required";
    if (!formValues.country_mob_code) errors.country_mob_code = "Mobile code is required";
    if (!formValues.project_no) errors.project_no = "Project No is required";
    if (!formValues.p_api_key) errors.p_api_key = "Project API Key is required";
    if (!formValues.template_api_key) errors.template_api_key = "Template API Key is required";
    if (!formValues.version) errors.version = "Version is required";
    if (!formValues.template_cost) errors.template_cost = "Template Cost  is required";
    if (!formValues.template_platform_cost) errors.template_platform_cost = "Template Platform Cost is required";
    if (!formValues.service_cost) errors.service_cost = "Service Cost  is required";
    if (!formValues.service_platform_cost) errors.service_platform_cost = "Service Platform Cost is required";
    if (!formValues.boat_id) errors.boat_id = "Boat ID is required";
    if (!formValues.client_id) errors.client_id = "Client ID is required";
    if (!formValues.google_id) errors.google_id = "Google ID is required";
    if (!formValues.client_name) errors.client_name = "Client Name is required";
    if (!formValues.client_type) errors.client_type = "Client Type is required";
    if (!formValues.access_token_validity) errors.access_token_validity = "Access Token Validity is required";
    if (!formValues.client_secret) errors.client_secret = "Client Secret is required";

    
    
    
    
    
    
    
    
    
    
    
    
    
    

    setFormErrors(errors, Object.keys(errors).length === 0);
    return Object.keys(errors).length === 0;
  };

  const handleChangePage = async (event, newPage) => {
    const updatedPage = newPage + 1;
    await fetchUsers(updatedPage, rowsPerPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = async (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    await fetchUsers(page, parseInt(event.target.value));
  };

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };
  const [anchorEl, setAnchorEl] = useState(null);

  const handleConfirm = async () => {
    await deleteDealer(selectedRow?.user_id);
    fetchUsers(page, rows, debouncedQuery)
  };

  // Example cancel action
  const handleCancel = () => {
    console.log("Rejected");
  };

  const handleMenuAction = async (action) => {
    if (action === "delete") {
      openDialog(
        "Delete Confirmation",
        "Are you sure you want to delete this item?"
      );
    }

    if (action === "manage-waba") {
      navigate("/admin/manage-waba", { state: { selectedRow } });
    }

    if (action === "edit") {
      setFormValues((prevValues) => ({
        ...prevValues,
        dealerCode: "",
      }));
      setShowCheck(false);
      setUpdate(true);
      patchValues(selectedRow);
      setIsAddModalOpen(true);
    }
    if (action === "changePassword") {
      setShowCheck(false);
      setChangePasswordModal(true);
    }

    handleClose();
  };

  const modalClose = () => {
    setUpdate(false);
    setShowCheck(true);
    setFormErrors({});
    setFormValues({});
    setIsAddModalOpen(!isAddModalOpen);
    setProjectAPIKeyAvailable(false)
    setTemplateAPIKeyAvailable(false)
  
  };

  const handleClose = () => {
    setAnchorEl(null);
    // setSelectedRow(null);
  };

  const fetchUsers = async (page = 1, limit = 10, query = "") => {
    try {
      const res = await apiCall({
        endpoint: `admin/get-users?page=${page}&limit=${limit}&search=${query}`,
        method: "GET",
      });
      if (res?.success) {
        setRows(res?.data || []);
        setCount(res?.total);
      }
    } catch (err) {
      // console.log(err,'error:1')

      setSnackBar({
        open: true,
        severity: false,
        message: err?.response?.data?.message || "An error occurred",
      });
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 1500);

    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  useEffect(() => {
    if (debouncedQuery) {
      fetchUsers(1, 10, debouncedQuery);
    } else {
      fetchUsers();
    }
  }, [debouncedQuery]);



  const getDealer = async (dealerCode) => {
    try {
      const res = await apiCall({
        endpoint: `admin/get-dealer/${dealerCode}`,
        method: "GET",
      });
      if (res?.success) {
        return res?.data;
      }
    } catch (err) {
      setDealerCodeAvailable(true);
    }
  };

  const deleteDealer = async (dealerCode) => {
    // console.log('dealerCode11:', dealerCode)
    const showSnackBar = (snackBarData) => setSnackBar(snackBarData);
    await deleteDealers(dealerCode, showSnackBar);
    const newRows = rows.filter((el) => el.id !== dealerCode);
    setCount(newRows.length);
    setRows(newRows);
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      let res = "";
      const showSnackBar = (snackBarData) => setSnackBar(snackBarData);
      if (update) {
        res = await UpdateUser(selectedRow?.user_id, formValues, showSnackBar);
      } else {
        res = await AddUser(formValues, showSnackBar);
      }
      if (res?.success) {
        setIsAddModalOpen(false);
        setFormErrors({});
        setFormValues({});
        await fetchUsers();
      }
    }
  };
  const patchValues = (data) => {
    if (data) {
      setFormValues({
        dealerCode: data.user_id || formValues.dealerCode,
        companyName: data.company_name || formValues.companyName,
        dealerName: data.user_name || formValues.dealerName,
        tradeName: data.trade_name || formValues.tradeName,
        location: data.location || formValues.location,
        state: data.state || formValues.state,
        district: data.district || formValues.district,
        city: data.city || formValues.city,
        region: data.region || formValues.region,
        zone: data.zone || formValues.zone,
        uemail: data.user_email || formValues.uemail,
        mobile: data.user_phone || formValues.mobile,
        upassword: formValues.upassword,
        apiKey: data.api_key,
        status: data?.status || formValues.status,
        // oem_id:data.oem_id || formValues.oem_id,
        // oem_dealer:data.dealer_code || formValues.oem_dealer,
        country_mob_code:data.country_mob_code || formValues.country_mob_code,
        project_no:data.country_mob_code || formValues.project_no,
        p_api_key:data.p_api_key || formValues.p_api_key,
        template_api_key:data.template_api_key || formValues.template_api_key,
        version:data.version || formValues.version,
        template_cost:data.template_cost || formValues.template_cost,
        template_platform_cost:data.template_platform_cost || formValues.template_platform_cost,
        service_cost:data.service_cost || formValues.service_cost,
        service_platform_cost:data.service_platform_cost || formValues.service_platform_cost,
        boat_id:data.boat_id || formValues.boat_id,
        client_id:data.client_id || formValues.client_id,
        google_id:data.google_id || formValues.google_id,
        client_name:data.client_name || formValues.client_name,
        client_type:data.client_type || formValues.client_type,
        access_token_validity:data.access_token_validity || formValues.access_token_validity,
        client_secret:data.client_secret || formValues.client_secret
      });
    }
  };
  const checkDealer = async (e) => {
    e.preventDefault();

    // Validate dealerCode
    if (!formValues?.dealerCode) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        dealerCode: "Dealer Code is required",
      }));
      return;
    }

    if (!formValues?.dealerCode) {
      // Assuming dealer code should be 6 digits
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        dealerCode: "Please enter dealer code",
      }));
      return;
    }

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      dealerCode: null,
    }));

    const dealerCode = formValues?.dealerCode;
    const data = await getDealer(dealerCode);
    if (data) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        dealerCode: "Dealer Already exists",
      }));
      setShowCheck(false);
    } else {
      setDealerCodeAvailable(true);
    }
  };

  // For Project API
  const getMsgToken = async ( client_id, client_secret ) => {
    try {
      const res = await apiCall({
        endpoint: `admin/get-msg-token?client_id=${client_id}&client_secret=${client_secret}`,
        method: "GET",
      });
      if (res?.success) {
        return ({ success:true, data:res?.data });
      }
      else if(!res?.success){
        return ({ success:false, data:null, error:res?.error}); 
      }

    } catch (err) {
      return ({ success:false, data:null, error:err?.response?.data?.error}); 

    }
  };

  const checkProjectAPIKey = async (e) => {
    e.preventDefault();

    const client_id = formValues?.client_id;
    // console.log('client_id__: ', client_id);
    const client_secret = formValues?.client_secret;
    // console.log('client_secret__: ', client_secret);
    
    // Validate dealerCode  
    if(client_id){
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        client_id: null
      }));
    }
    else if(client_secret){
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        client_secret: null
      }));
    }
      
    if (!client_id ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        client_id: `Client ID is required`,
      }));
      return;
    }else{
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        client_id: null
      }));
    }
    
    if(!client_secret ){
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        client_secret: `Client Secret is required`,
      }));
      return;
    }else{
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        client_secret: null
      }));
    }
    
  
    const getMsgTokenRes = await getMsgToken(client_id, client_secret);
    console.log('getMsgTokenRes: ', getMsgTokenRes);
    if(getMsgTokenRes.success){
      setFormValues((preValues)=>({
        ...preValues,
        p_api_key: getMsgTokenRes.data.access_token
      }))
      setProjectAPIKeyAvailable(true)

    }else if(!getMsgTokenRes.success){
      alert( getMsgTokenRes.error)
      setProjectAPIKeyAvailable(false)
    }
  };

  // For Template API
  const getTemplateToken = async () => {
    try {
      const res = await apiCall({
        endpoint: `admin/get-template-token`,
        method: "GET",
      });
      console.log('res?.data: ', res?.data);
      if (res?.success) {
        return ({ success:true, data:res?.data });
      }
      else if(!res?.success){
        return ({ success:false, data:null, error:res?.error}); 
      }

    } catch (err) {
      return ({ success:false, data:null, error:err?.response?.data?.error}); 

    }
  };

  const checkTemplateAPIKey = async (e) => {
    e.preventDefault();

    const getTemplateTokeRes = await getTemplateToken();
    if(getTemplateTokeRes.success){
      setFormValues((preValues)=>({
        ...preValues,
        template_api_key: getTemplateTokeRes.data.access_token
      }))
      setTemplateAPIKeyAvailable(true)

    }else if(!getTemplateTokeRes.success){
      alert( getTemplateTokeRes.error)
      setTemplateAPIKeyAvailable(false)
    }
  }

  const checkApiKey = async (e) => {
    e.preventDefault();
    const showSnackBar = (snackBarData) => setSnackBar(snackBarData);
    const apiKey = formValues.apiKey;
    const res = await GetPinnacleUser(apiKey, showSnackBar);
    if (res && res?.data?.length) {
      // setShowWhatsappField(true);
      setShowCheckApi(false);
      setFormValues({
        ...formValues,
        whatsappBusinessAccountId: res?.data?.[0].whatsapp_business_account_id, // Direct property name
      });
    } else {
      // setShowWhatsappField(false);
      setShowCheckApi(true);
      setFormValues({
        ...formValues,
        whatsappBusinessAccountId: "", // Direct property name
      });
    }
  };

  const handlePasswordInput = (e) => {
    const { id, value } = e.target;
    setPasswords({
      ...passwords,
      [id]: value,
    });
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      const { password, confirmPassword } = passwords;

      if (password === "" || confirmPassword === "") {
        setErrorMessage("Both fields are required");
        return;
      }
      if (password !== confirmPassword) {
        setErrorMessage("Passwords do not match");
        return;
      }
      if (selectedRow?.user_id) {
        const showSnackBar = (snackBarData) => setSnackBar(snackBarData);
        const res = await ChangePassword(
          selectedRow.user_id,
          passwords,
          showSnackBar
        );
        if (res?.success) {
          setChangePasswordModal(false);
          setPasswords({});
          setErrorMessage("");
        }
      }
    } catch (err) {
      setChangePasswordModal(false);
      setErrorMessage("");
      setSnackBar({
        open: true,
        severity: false,
        message: err?.response?.data?.message || "An error occurred",
      });
    } finally {
    }
  };

  return (
    <>
      <div className="Template_id_contian">
        <h4 className="Head_title AdminSearchContain">
          Manage User
          <div className="Session_report_SearchContain">
            <input
              placeholder="Search"
              type="text"
              value={searchQuery}
              onChange={handleSearch} // Trigger search on every input change
            />
            <button type="button">
              <SearchIcon />
            </button>
          </div>
          <button className="add_btn6" onClick={handleAddModalToggle}>
            <img src={Plus} alt="img" /> New
          </button>
        </h4>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table" className="Table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.id === "created_date" ? (
                              formatDate(value) // Format as DD-MM-YYYY
                            ) : column.id === "action" ? (
                              <>
                                <IconButton
                                  aria-controls="simple-menu"
                                  aria-haspopup="true"
                                  onClick={(event) => handleClick(event, row)}
                                >
                                  <MoreVertIcon />
                                </IconButton>
                                <Menu
                                  id="simple-menu"
                                  anchorEl={anchorEl}
                                  keepMounted
                                  open={Boolean(anchorEl)}
                                  onClose={handleClose}
                                  className="BoxShadowNone"
                                >
                                  <MenuItem
                                    onClick={() => handleMenuAction("edit")}
                                  >
                                    <EditIcon className="icon-spacing" />
                                    Edit
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() =>
                                      handleMenuAction("manage-waba")
                                    }
                                  >
                                    <ManageAccountsIcon className="icon-spacing" />
                                    Manage Waba
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => handleMenuAction("delete")}
                                  >
                                    <DeleteForeverIcon className="icon-spacing" />
                                    Delete
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() =>
                                      handleMenuAction("changePassword")
                                    }
                                  >
                                    <LockResetIcon className="icon-spacing" />
                                    Change Password
                                  </MenuItem>
                                </Menu>
                                {ChangePasswordModal ? (
                                  <div className="DChangePasswordModalContain">
                                    <div className="DChangePasswordModal">
                                      <h4>Change Password</h4>
                                      <form onSubmit={handlePasswordSubmit}>
                                        <div className="DFormgroupContain">
                                          <div className="DFormgroup">
                                            <label htmlFor="password">
                                              Password
                                            </label>
                                            <input
                                              type="password"
                                              id="password"
                                              placeholder="Enter Your Password"
                                              value={passwords.password}
                                              onChange={handlePasswordInput}
                                            />
                                          </div>
                                          <div className="DFormgroup">
                                            <label htmlFor="cpassword">
                                              Confirm Password
                                            </label>
                                            <input
                                              type="password"
                                              id="confirmPassword"
                                              placeholder="Enter Your Password"
                                              value={passwords.confirmPassword}
                                              onChange={handlePasswordInput}
                                            />
                                          </div>
                                          {errorMessage && (
                                            <p className="error">
                                              {errorMessage}
                                            </p>
                                          )}
                                          <div className="DFormgroup">
                                            <button
                                              type="submit"
                                              className="save"
                                            >
                                              Save
                                            </button>
                                            <button
                                              type="button"
                                              className="cancel ms-2"
                                              onClick={() => {
                                                setChangePasswordModal(false);
                                                setPasswords({});
                                                setErrorMessage("");
                                              }}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : column.format && typeof value === "number" ? (
                              column.format(value)
                            ) : (
                              value
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
      {isAddModalOpen && (
        <div className="modal fade show d-block manage_dealer_form wb_mange_content">
          <div className="modal-dialog-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {update ? "Update Dealer" : "Add Dealer"}
                </h5>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="form-container">
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="dealerCode">
                          Dealer Code <span className="required_icon">*</span>
                        </label>
                        <>
                          <input
                            type="text"
                            name="dealerCode"
                            placeholder="Enter Dealer Code"
                            value={formValues.dealerCode || ""}
                            onChange={handleInputChange}
                            readOnly={update}
                          />
                          {formErrors.dealerCode && (
                            <span className="error">
                              {formErrors.dealerCode}
                            </span>
                          )}
                          {showCheck && !update && (
                            <>
                              {!dealerCodeAvailable ? (
                                <button
                                  onClick={checkDealer}
                                  className="check-dealer-button bg_blue"
                                >
                                  Check
                                </button>
                              ) : (
                                <p
                                  style={{ color: "green" }}
                                  className="validation_green"
                                >
                                  Dealer code available
                                </p>
                              )}
                            </>
                          )}
                        </>
                      </div>
                      <div className="form-group">
                        <label htmlFor="companyName">
                          Company Name <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="companyName"
                          placeholder="Enter Company Name"
                          value={formValues.companyName || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.companyName && (
                          <span className="error">
                            {formErrors.companyName}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="dealerName">
                          Dealer Name <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="dealerName"
                          placeholder="Enter Dealer Name"
                          value={formValues.dealerName || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.dealerName && (
                          <span className="error">{formErrors.dealerName}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      
                      {/* <div className="form-group">
                        <label htmlFor="apiKey">
                          API Key <span className="required_icon">*</span>
                        </label>
                        <>
                          <input
                            type="text"
                            name="apiKey"
                            placeholder="Enter API Key"
                            value={formValues.apiKey || ""}
                            onChange={handleInputChange}
                            readOnly={update}
                          />
                          {formErrors.apiKey && (
                            <span className="error">{formErrors.apiKey}</span>
                          )}
                          {showCheckApi && !update && (
                            <button
                              onClick={checkApiKey}
                              className="check-dealer-button bg_blue"
                            >
                              Check
                            </button>
                          )}
                        </>
                      </div> */}

                      <div className="form-group">
                        <label htmlFor="uemail">
                          Email <span className="required_icon">*</span>
                        </label>
                        <input
                          type="email"
                          name="uemail"
                          placeholder="Enter Email"
                          value={formValues.uemail || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.email && (
                          <span className="error">{formErrors.email}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="country_mob_code">
                          Mobile Code <span className="required_icon">*</span>
                        </label>
                        <input
                          type="number"
                          name="country_mob_code"
                          placeholder="Enter Mobile Code"
                          value={formValues.country_mob_code || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.country_mob_code && (
                          <span className="error">{formErrors.country_mob_code}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="mobile">
                          Mobile <span className="required_icon">*</span>
                        </label>
                        <input
                          type="number"
                          name="mobile"
                          placeholder="Enter Mobile"
                          value={formValues.mobile || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.mobile && (
                          <span className="error">{formErrors.mobile}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="zone">
                          Zone <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="zone"
                          placeholder="Enter Zone"
                          value={formValues.zone || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.zone && (
                          <span className="error">{formErrors.zone}</span>
                        )}
                      </div>

                      {!update && (
                        <div className="form-group">
                          <label htmlFor="upassword">
                            Password <span className="required_icon">*</span>
                          </label>
                          <input
                            type={isPasswordVisible ? "text" : "password"}
                            name="upassword"
                            placeholder="Enter Password"
                            value={formValues.upassword || ""}
                            onChange={handleInputChange}
                          />
                          <button
                            type="button"
                            className="PSIcon"
                            onClick={togglePasswordVisibility}
                          >
                            {isPasswordVisible ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </button>
                        </div>
                      )}
                      <div className="form-group">
                        <label htmlFor="location">
                          Location <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="location"
                          placeholder="Enter Location"
                          value={formValues.location || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.location && (
                          <span className="error">{formErrors.location}</span>
                        )}
                      </div>
                      
                      
                      
                    </div>
                    <div className="form-row">
                        
                    <div className="form-group">
                        <label htmlFor="state">
                          State <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="state"
                          placeholder="Enter State"
                          value={formValues.state || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.state && (
                          <span className="error">{formErrors.state}</span>
                        )}
                      </div>

                      <div className="form-group">
                        <label htmlFor="district">
                          District <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="district"
                          placeholder="Enter District"
                          value={formValues.district || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.district && (
                          <span className="error">{formErrors.district}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="city">
                          City <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="city"
                          placeholder="Enter City"
                          value={formValues.city || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.city && (
                          <span className="error">{formErrors.city}</span>
                        )}
                      </div>
                      
                   
                    </div>

                    <div className="form-row">
                      
                    <div className="form-group">
                        <label htmlFor="region">
                          Region <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="region"
                          placeholder="Enter Region"
                          value={formValues.region || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.region && (
                          <span className="error">{formErrors.region}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="tradeName">
                          Trade Name <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="tradeName"
                          placeholder="Enter Trade Name"
                          value={formValues.tradeName || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.tradeName && (
                          <span className="error">{formErrors.tradeName}</span>
                        )}
                      </div>                                        
                      <div className="form-group">
                        <label htmlFor="project_no">
                          Project No. <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="project_no"
                          placeholder="Enter Project No"
                          value={formValues.project_no || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.project_no && (
                          <span className="error">{formErrors.project_no}</span>
                        )}
                      </div>
                      
                      

                      
                    </div>

                    <div className="form-row">
                      

                      <div className="form-group">
                        <label htmlFor="google_id">
                          Google ID <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="google_id"
                          placeholder="Enter Google ID"
                          value={formValues.google_id || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.google_id && (
                          <span className="error">{formErrors.google_id}</span>
                        )}
                      </div>

                      <div className="form-group">
                        <label htmlFor="version">
                          Version <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="version"
                          placeholder="Enter Version"
                          value={formValues.version || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.version && (
                          <span className="error">{formErrors.version}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="template_cost">
                          Template Cost <span className="required_icon">*</span>
                        </label>
                        <input
                          type="number"
                          name="template_cost"
                          placeholder="Enter Template Cost"
                          value={formValues.template_cost || 0 }
                          onChange={handleInputChange}
                        />
                        {formErrors.template_cost && (
                          <span className="error">{formErrors.template_cost}</span>
                        )}
                      </div>
                      
                      
                    </div>

                    <div className="form-row">
                    
                    <div className="form-group">
                        <label htmlFor="template_platform_cost">
                          Template Platform Cost <span className="required_icon">*</span>
                        </label>
                        <input
                          type="number"
                          name="template_platform_cost"
                          placeholder="Enter Template Platform Cost"
                          value={formValues.template_platform_cost || 0 }
                          onChange={handleInputChange}
                        />
                        {formErrors.template_platform_cost && (
                          <span className="error">{formErrors.template_platform_cost}</span>
                        )}
                      </div>
                    <div className="form-group">
                        <label htmlFor="service_cost">
                          Service Cost <span className="required_icon">*</span>
                        </label>
                        <input
                          type="number"
                          name="service_cost"
                          placeholder="Enter Service Cost"
                          value={formValues.service_cost || 0 }
                          onChange={handleInputChange}
                        />
                        {formErrors.service_cost && (
                          <span className="error">{formErrors.service_cost}</span>
                        )}
                      </div>

                      <div className="form-group">
                        <label htmlFor="service_platform_cost">
                          Service Platform Cost <span className="required_icon">*</span>
                        </label>
                        <input
                          type="number"
                          name="service_platform_cost"
                          placeholder="Enter Service Platform Cost"
                          value={formValues.service_platform_cost || 0 }
                          onChange={handleInputChange}
                        />
                        {formErrors.service_platform_cost && (
                          <span className="error">{formErrors.service_platform_cost}</span>
                        )}
                      </div>
                      
                      
                    </div>

                    <div className="form-row">
                    
                    <div className="form-group">
                        <label htmlFor="boat_id">
                          Bot ID <span className="required_icon">*</span>
                        </label>
                        { update ?
                          <input
                            type="text"
                            name="boat_id"
                            placeholder="Enter Bot ID"
                            value={formValues.boat_id || ""}
                            onChange={handleInputChange}
                            disabled
                          />
                        :
                          <input
                          type="text"
                          name="boat_id"
                          placeholder="Enter Bot ID"
                          value={formValues.boat_id || ""}
                          onChange={handleInputChange}
                          />
                        }
                        {formErrors.boat_id && (
                          <span className="error">{formErrors.boat_id}</span>
                        )}
                      </div>
                    <div className="form-group">
                        <label htmlFor="client_id">
                          Client ID <span className="required_icon">*</span>
                        </label>

                        { update ?
                            <input
                              type="text"
                              name="client_id"
                              placeholder="Enter Client ID"
                              value={formValues.client_id || ""}
                              onChange={handleInputChange}
                              disabled
                            />
                        :
                            <input
                              type="text"
                              name="client_id"
                              placeholder="Enter Client ID"
                              value={formValues.client_id || ""}
                              onChange={handleInputChange}
                              
                            />
                        }

                        {formErrors.client_id && (
                          <span className="error">{formErrors.client_id}</span>
                        )}
                      </div>

                      <div className="form-group">
                        <label htmlFor="client_secret">
                          Client Secret <span className="required_icon">*</span>
                        </label>
                        { update ?
                          <input
                            type="text"
                            name="client_secret"
                            placeholder="Enter Client Secret"
                            value={formValues.client_secret || ""}
                            onChange={handleInputChange}
                            disabled
                          />
                          :
                          <input
                            type="text"
                            name="client_secret"
                            placeholder="Enter Client Secret"
                            value={formValues.client_secret || ""}
                            onChange={handleInputChange}
                          />
                        }

                        {formErrors.client_secret && (
                          <span className="error">{formErrors.client_secret}</span>
                        )}
                      </div>
                      
                                         
                    </div>

                    <div className="form-row">
                    
                    <div className="form-group">
                        <label htmlFor="client_name">
                          Client Name <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="client_name"
                          placeholder="Enter Client Name"
                          value={formValues.client_name || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.client_name && (
                          <span className="error">{formErrors.client_name}</span>
                        )}
                      </div>
                    <div className="form-group">
                        <label htmlFor="client_type">
                          Client Type <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="client_type"
                          placeholder="Enter Client Type"
                          value={formValues.client_type || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.client_type && (
                          <span className="error">{formErrors.client_type}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="tradeName">
                          Access Token Validity <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="access_token_validity"
                          placeholder="Enter Access Token Validity"
                          value={formValues.access_token_validity || ""}
                          onChange={handleInputChange}
                        />
                        
                        {formErrors.access_token_validity && (
                          <span className="error">{formErrors.access_token_validity}</span>
                        )}
                      </div>
                      
                      
                    </div>

                    <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="template_api_key">
                          Template API Key. <span className="required_icon">*</span>
                        </label>

                        <input
                          type="text"
                          name="template_api_key"
                          placeholder="Enter Template API Key"
                          value={formValues.template_api_key || ""}
                          onChange={handleInputChange}
                          disabled
                        />

                        { !update ?
                          !templateAPIKeyAvailable ? (
                            <button
                              onClick={checkTemplateAPIKey}
                              className="check-dealer-button bg_blue"
                            >
                              Check
                            </button>
                          ) : (
                            <p
                              style={{ color: "green" }}
                              className="validation_green"
                            >
                              Template API Key Available
                            </p>
                          )

                          : ""
                        }

                        {formErrors.template_api_key && (
                          <span className="error">{formErrors.template_api_key}</span>
                        )}


                      </div>

                      <div className="form-group">
                        <label htmlFor="p_api_key">
                          Project API Key. <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="p_api_key"
                          placeholder="Enter Project API Key"
                          value={formValues.p_api_key || ""}
                          onChange={handleInputChange}
                          disabled
                        />

                      { !update ?
                          !projectAPIKeyAvailable ? (
                            <button
                              onClick={checkProjectAPIKey}
                              className="check-dealer-button bg_blue"
                            >
                              Check
                            </button>
                          ) : (
                            <p
                              style={{ color: "green" }}
                              className="validation_green"
                            >
                              Project API Key Available
                            </p>
                          )

                          : ""
                      }


                        {formErrors.p_api_key && (
                          <span className="error">{formErrors.p_api_key}</span>
                        )}
                      </div>


                      <div className="form-group">
                        <label htmlFor="status">
                          Status <span className="required_icon">*</span>
                        </label>
                        <select
                          name="status"
                          value={formValues.status || ""}
                          onChange={handleInputChange}
                        >
                          
                          <option value={formValues.status || "none"}>
                            {formValues.status || "Please Select Status"}
                          </option>
                          
                          {formValues.status ? (
                            <option value={formValues.status=='Active'?'Deactive':'Active'}>
                              {formValues.status=='Active'?'Deactive':'Active'}
                            </option>
                          ):(
                            <>
                            <option value="Active">Activate</option>
                            <option value="Deactive">Deactivate</option>
                            </>                             
                          )}


                        </select>
                        {formErrors.status && (
                          <span className="error">{formErrors.status}</span>
                        )}
                      </div>
                    </div>
                   

                    <div className="form-row">

  {/* <div className="form-group">
                        <label htmlFor="oem_dealer">
                          Oem DealerCode 
                        </label>
                        <input
                          type="text"
                          name="oem_dealer"
                          placeholder="Enter Dealercode"
                          value={formValues.oem_dealer}
                          onChange={handleInputChange}
                        />
                  
                      </div>

                      <div className="form-group">
                        <label htmlFor="oem_id"> OEM ID </label>
                        <input
                          type="text"
                          name="oem_id"
                          placeholder="Enter OEM ID"
                          value={formValues.oem_id || ""}
                          onChange={handleInputChange}
                        />                     
                      </div> */}
                      </div>
                  </div>
                  <div className="modal-footer">
                    <button type="submit" className="btn btn-primary">
                      {update ? "Update" : "Save"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={modalClose}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      <AlertDialog
        open={open}
        setOpen={setOpen}
        title={dialogTitle}
        description={dialogDescription}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      <ShowSnackBar
        open={snackBar.open}
        severity={snackBar.severity}
        message={snackBar.message}
        onClose={handleCloseSnackBar}
      />
    </>
  );
};

export default WbManageDealer;
